import { useExperience } from '@mc/experience'
import type { getUserAttributes } from '@mc/next-user-attributes'
import { useStaticData } from '@mc/static-data-react'
import { isEnterpriseMembership } from './isEnterpriseMembership'

type UserAttributes = ReturnType<typeof getUserAttributes>

export const useIsEnterpriseMember = (): boolean => {
  const { userAttributes } = useStaticData<{
    userAttributes?: UserAttributes
  }>()
  const { isEnterprise } = useExperience()
  return isEnterpriseMembership(userAttributes?.membership) || isEnterprise
}
